import * as Yup from 'yup';

const DAY_KEYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const daySchema = Yup.object().shape({
  start_time: Yup.string().required('Start time is required'),
  end_time: Yup.string().required('End time is required'),
  price_per_hour: Yup.number()
    .typeError('Price per hour must be a number')
    .min(0, 'Price per hour cannot be negative')
    .required('Price per hour is required'),
  slots_available: Yup.number()
    .typeError('Slots available must be a number')
    .integer('Slots available must be a whole number')
    .min(1, 'There must be at least one slot')
    .required('Slots available is required'),
  space_type: Yup.string().required('Space type is required'),
});

/**
 * Builds a validation schema that only validates the days the user has turned
 * on. Validation here is conditional because a retail profile can be open on
 * any subset of days; only active days feed the submit payload, so only those
 * need to be complete. Mirrors the fields consumed in handleSubmit.
 *
 * @param {Record<string, boolean>} activeDays map of day -> enabled
 */
export const buildCreateRetailProfileSchema = (activeDays = {}) => {
  const shape = {
    start_date: Yup.mixed().nullable(),
    end_date: Yup.mixed().nullable(),
  };

  DAY_KEYS.forEach((day) => {
    shape[day] = activeDays[day] ? daySchema : Yup.object().nullable();
  });

  return Yup.object().shape(shape);
};

export default buildCreateRetailProfileSchema;
